import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  title,
  subtitle,
  icon = 'ri-fire-line',
  moreTo,
  moreLabel = '查看更多',
  children,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4 border-b border-background-200 pb-3">
      <div className="flex items-center gap-3">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-50 text-primary-600">
          <i className={icon} />
        </span>
        <div>
          <h2 className="font-heading text-lg font-bold text-foreground-950">{title}</h2>
          {subtitle ? <p className="text-xs text-foreground-500">{subtitle}</p> : null}
        </div>
      </div>
      <div className="flex items-center gap-3">
        {children}
        {moreTo ? (
          <Link
            to={moreTo}
            className="flex items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-600 transition-colors hover:text-accent-600 cursor-pointer"
          >
            {moreLabel}
            <i className="ri-arrow-right-s-line" />
          </Link>
        ) : null}
      </div>
    </div>
  );
}